'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Break this up a bit more, so that consumers aren't calling data.data.getData()
/**
 * @class WebRTCData
 */
var WebRTCData = function () {
  /**
   * @param {Object} data
   */
  function WebRTCData(data) {
    (0, _classCallCheck3.default)(this, WebRTCData);

    this.data = data;
    this.id = _uuid2.default.v4();
  }

  /**
   * get the unique id for this specific stat pull
   * @returns {String};
   */


  (0, _createClass3.default)(WebRTCData, [{
    key: 'getId',
    value: function getId() {
      return this.id;
    }

    /**
     * get the transformed data
     * @returns {Object}
     */

  }, {
    key: 'getData',
    value: function getData() {
      return this.data;
    }
  }]);
  return WebRTCData;
}();

exports.default = WebRTCData;
//# sourceMappingURL=data.js.map
